export enum ConventionalInfoDataType {
    String,
    Numeric,
    DateTime,
    Boolean
}
